var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_66_2166",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 8,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27408 0.469665C9.5751 0.762551 9.5751 1.23741 9.27408 1.5303L4.68033 5.99987L9.27408 10.4694C9.5751 10.7623 9.5751 11.2372 9.27408 11.5301C8.97306 11.823 8.485 11.823 8.18398 11.5301L2.50012 5.99987L8.18398 0.469665C8.485 0.176778 8.97306 0.176778 9.27408 0.469665Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_66_2166)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    y: -0.000976562,
    width: 11.9995,
    height: 11.9997,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.ca6dd4b8dd589950de1efe2215ffc0f8.svg";
export { ForwardRef as ReactComponent };